import { CreateDetergentHistoryRequest } from '@/types/apis/detergentHistories/CreateDetergentHistoryRequest'
import { CreateDetergentHistoryResponse } from '@/types/apis/detergentHistories/CreateDetergentHistoryResponse'
import { DeleteDetergentHistoryRequest } from '@/types/apis/detergentHistories/DeleteDetergentHistoryRequest'
import { GetAllDetergentHistoryResponse } from '@/types/apis/detergentHistories/GetAllDetergentHistoryResponse'
import { GetAllDetergentHistoryRequest } from '@/types/apis/detergentHistories/GetAllDetergntHistoryRequest'
import { GetDetergentHistoryRequest } from '@/types/apis/detergentHistories/GetDetergentHistoryRequest'
import { GetDetergentHistoryResponse } from '@/types/apis/detergentHistories/GetDetergentHistoryResponse'
import { UpdateDetergentHistoryRequest } from '@/types/apis/detergentHistories/UpdateDetergentHistoryRequest'
import { UpdateDetergentHistoryResponse } from '@/types/apis/detergentHistories/UpdateDetergentHistoryResponse'

import axios from './axios'

const API_ENDPOINT = '/detergent/history'

export const getAllDetergentHistories = (
  request: GetAllDetergentHistoryRequest
): Promise<GetAllDetergentHistoryResponse> => {
  return axios.get(`${API_ENDPOINT}`, { params: request })
}

export const getDetergentHistory = (request: GetDetergentHistoryRequest): Promise<GetDetergentHistoryResponse> => {
  return axios.get(`${API_ENDPOINT}/${request.id}`)
}

export const createDetergentHistory = (
  request: CreateDetergentHistoryRequest
): Promise<CreateDetergentHistoryResponse> => {
  return axios.post(`${API_ENDPOINT}`, request)
}

export const updateDetergentHistory = (
  request: UpdateDetergentHistoryRequest
): Promise<UpdateDetergentHistoryResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteDetergentHistory = (
  request: DeleteDetergentHistoryRequest
): Promise<UpdateDetergentHistoryResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}
